import { Box, Button, Container, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { login } from '../../api/endpoints';
import CustomTextField from '../../components/CustomTextField';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token) {
      navigate('/', { replace: true });
    }
  }, []);

  const handleLogin = async (event: React.FormEvent) => {
    event.preventDefault();
    try {
      const response = await login(email, password);
      if (response?.access_token) {
        localStorage.setItem('access_token', response.access_token);
        localStorage.setItem('username', response.username);
        navigate('/');
      } else {
        toast.error('Invalid email or password.');
      }
    } catch (error) {
      console.error('Login error:', error);
      toast.error('An error occurred during login.');
    }
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        px: 0,
      }}
    >
      <Box
        sx={{
          borderRadius: '12px',
          backgroundColor: '#fff',
          width: '600px',
          height: '100vh',
          textAlign: 'center',
          // py: '20px',
        }}
      >
        <Box sx={{ marginTop: '80px' }}>
          <Box sx={{ textAlign: 'start', px: { xs: 3, sm: 6, md: 10 }, my: 4 }}>
            <Typography
              variant="h5"
              sx={{ color: '#555', mb: 1, fontSize: { xs: '18px', sm: '20px', md: '22px' } }}
            >
              The Future of Retail
            </Typography>

            <Typography
              variant="h5"
              sx={{
                color: '#2653cb',
                fontWeight: '700',
                fontSize: { xs: '22px', sm: '28px' },
              }}
            >
              Walmart Sentiment AI
            </Typography>

            <Typography
              variant="h5"
              sx={{
                color: '#215cc1',
                fontWeight: '500',
                mb: 2,
                fontSize: { xs: '18px', sm: '24px' },
              }}
            >
              Admin Login
            </Typography>
          </Box>

          <Box sx={{ textAlign: 'start', width: '90%', mx: { xs: 'none', sm: 'auto' } }}>
            <Box sx={{ pb: 2 }}>
              <CustomTextField
                placeholder="admin@example.com"
                label="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                sx={{ borderRadius: '30px' }}
              />
            </Box>
            <Box>
              <CustomTextField
                placeholder="*****"
                label="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
              />
            </Box>
          </Box>
          <form onSubmit={handleLogin}>
            <Box sx={{ marginTop: { xs: '60px', sm: '30px' } }}>
              <Button
                type="submit"
                variant="contained"
                disabled={!email || !password}
                sx={{
                  backgroundColor: '#0057FF',
                  borderRadius: '20px',
                  padding: '8px',
                  width: { xs: '90%', sm: '70%' },
                  fontWeight: 'bold',
                  mt: 2,
                  '&:hover': { backgroundColor: '#0043CC' },
                }}
              >
                Login
              </Button>
            </Box>
          </form>
        </Box>
      </Box>
    </Container>
  );
};

export default LoginPage;
